import { Button } from 'react-bootstrap';
import UserAdminItems from './UsersRowItems/UserAdminItems';
import UserNameItem from './UsersRowItems/UserNameItem';
import UserStatItems from './UsersRowItems/UserStatItem';
import type { UserRowProps } from './types';
import SolarIcon from 'components/icons/SolarIcon';

const UsersTableRow = ({ user, setShowSpinner, fetchUsers, setShowUserCard }: UserRowProps) => {
    return (
        <tr>
            <td className="username">
                <UserNameItem user={user} setShowUserCard={setShowUserCard} />
            </td>
            <td className="admin">
                <UserAdminItems user={user} />
            </td>
            <td className="status">
                <UserStatItems fetchUsers={fetchUsers} setShowSpinner={setShowSpinner} user={user} />
            </td>
            <td className="action">
                <Button
                    className="p-1 py-0"
                    size="sm"
                    variant="light-secondary"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        setShowUserCard(user.ID);
                    }}>
                    <SolarIcon name="three-dots" />
                </Button>
            </td>
        </tr>
    );
};

export default UsersTableRow;
